<template>
  <section>
    <base-card>
      <h2>Page Not Found</h2>
      <p>
        This Page Could Not Be Found - Check Out Our
        <router-link to="/coaches"> Coaches</router-link>
      </p>
    </base-card>
  </section>
</template>
